// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ComGrid[data-v-f5a2dad4]{color:#fff}.ComGrid .container[data-v-f5a2dad4]{display:grid;gap:10px;text-align:left;margin-top:20px}.ComGrid .grid_font[data-v-f5a2dad4]{font-size:1rem;font-weight:bolder}.ComGrid .grid_piece[data-v-f5a2dad4]{padding:15px;background-size:100% 100%;background-repeat:no-repeat}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
